"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cesena": {
    "abb01b18": [{
      "hkey": "b8fa3ad0",
      "slug": "bagnile-pontecucco-san-giorgio",
      "name": "Bagnile-Pontecucco-San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "bagnile": [{
      "hkey": "b8fa3ad0",
      "slug": "bagnile-pontecucco-san-giorgio",
      "name": "Bagnile-Pontecucco-San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5e235284": [{
      "hkey": "281c98a5",
      "slug": "borello-formignano-gallo-luzzena",
      "name": "Borello-Formignano-Gallo-Luzzena",
      "primary": true,
      "skipSearch": false
    }],
    "borello": [{
      "hkey": "281c98a5",
      "slug": "borello-formignano-gallo-luzzena",
      "name": "Borello-Formignano-Gallo-Luzzena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "392f968f": [{
      "hkey": "139a91b4",
      "slug": "san-martino-in-fiume-ronta",
      "name": "San Martino in Fiume-Ronta",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-di-ronta": [{
      "hkey": "139a91b4",
      "slug": "san-martino-in-fiume-ronta",
      "name": "San Martino in Fiume-Ronta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "41ff6883": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-paglia": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "e9457b63": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "calabrina": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "605b41b6": [{
      "hkey": "fa2405aa",
      "slug": "calisese-madonna-dell-ulivo",
      "name": "Calisese-Madonna dell'Ulivo",
      "primary": true,
      "skipSearch": false
    }],
    "calisese": [{
      "hkey": "fa2405aa",
      "slug": "calisese-madonna-dell-ulivo",
      "name": "Calisese-Madonna dell'Ulivo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3f4d624a": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "capannaguzzo": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "aa29be2e": [{
      "hkey": "764bb0bd",
      "slug": "carpineta-casale",
      "name": "Carpineta-Casale",
      "primary": true,
      "skipSearch": false
    }],
    "carpineta": [{
      "hkey": "764bb0bd",
      "slug": "carpineta-casale",
      "name": "Carpineta-Casale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bfa39178": [{
      "hkey": "764bb0bd",
      "slug": "carpineta-casale",
      "name": "Carpineta-Casale",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "764bb0bd",
      "slug": "carpineta-casale",
      "name": "Carpineta-Casale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "84fc996e": [{
      "hkey": "fc592bfd",
      "slug": "case-castagnoli-case-missiroli",
      "name": "Case Castagnoli-Case-Missiroli",
      "primary": true,
      "skipSearch": false
    }],
    "case-castagnoli": [{
      "hkey": "fc592bfd",
      "slug": "case-castagnoli-case-missiroli",
      "name": "Case Castagnoli-Case-Missiroli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "f851f218": [{
      "hkey": "6590aeae",
      "slug": "case-finali-fiorita-ospedale-san-pietro",
      "name": "Case Finali-Fiorita-Ospedale-San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "case-finali": [{
      "hkey": "6590aeae",
      "slug": "case-finali-fiorita-ospedale-san-pietro",
      "name": "Case Finali-Fiorita-Ospedale-San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2dec07c2": [{
      "hkey": "edb7aa0c",
      "slug": "sant-egidio-vigne-case-frini",
      "name": "Sant'Egidio-Vigne-Case Frini",
      "primary": true,
      "skipSearch": false
    }],
    "case-frini": [{
      "hkey": "edb7aa0c",
      "slug": "sant-egidio-vigne-case-frini",
      "name": "Sant'Egidio-Vigne-Case Frini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "f29b0c3e": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "skipSearch": false
    }],
    "case-gentili": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "8d6e2bc4": [{
      "hkey": "fc592bfd",
      "slug": "case-castagnoli-case-missiroli",
      "name": "Case Castagnoli-Case-Missiroli",
      "primary": true,
      "skipSearch": false
    }],
    "case-missiroli": [{
      "hkey": "fc592bfd",
      "slug": "case-castagnoli-case-missiroli",
      "name": "Case Castagnoli-Case-Missiroli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "39c17c4e": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "skipSearch": false
    }],
    "case-scuola-vecchia": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "8b4f66c7": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "5814ad78": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-urbano": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "512e8dd4": [{
      "hkey": "281c98a5",
      "slug": "borello-formignano-gallo-luzzena",
      "name": "Borello-Formignano-Gallo-Luzzena",
      "primary": true,
      "skipSearch": false
    }],
    "gallo": [{
      "hkey": "281c98a5",
      "slug": "borello-formignano-gallo-luzzena",
      "name": "Borello-Formignano-Gallo-Luzzena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "8907944e": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "gattolino": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "a5493b12": [{
      "hkey": "d4fa3da9",
      "slug": "ippodromo-torre-del-moro",
      "name": "Ippodromo-Torre del Moro",
      "primary": true,
      "skipSearch": false
    }],
    "ippodromo": [{
      "hkey": "d4fa3da9",
      "slug": "ippodromo-torre-del-moro",
      "name": "Ippodromo-Torre del Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3a24172c": [{
      "hkey": "e8ef6ea9",
      "slug": "san-carlo-san-vittore-tessello",
      "name": "San Carlo-San Vittore-Tessello",
      "primary": true,
      "skipSearch": false
    }],
    "le-aie": [{
      "hkey": "e8ef6ea9",
      "slug": "san-carlo-san-vittore-tessello",
      "name": "San Carlo-San Vittore-Tessello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "b7796ee6": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "skipSearch": false
    }],
    "lizzano": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "d87af416": [{
      "hkey": "281c98a5",
      "slug": "borello-formignano-gallo-luzzena",
      "name": "Borello-Formignano-Gallo-Luzzena",
      "primary": true,
      "skipSearch": false
    }],
    "luzzena": [{
      "hkey": "281c98a5",
      "slug": "borello-formignano-gallo-luzzena",
      "name": "Borello-Formignano-Gallo-Luzzena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "8a428c98": [{
      "hkey": "e03aade9",
      "slug": "bulgarno-macerone-ruffio",
      "name": "Bulgarnò-Macerone-Ruffio",
      "primary": true,
      "skipSearch": false
    }],
    "macerone": [{
      "hkey": "e03aade9",
      "slug": "bulgarno-macerone-ruffio",
      "name": "Bulgarnò-Macerone-Ruffio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9804c52f": [{
      "hkey": "fa2405aa",
      "slug": "calisese-madonna-dell-ulivo",
      "name": "Calisese-Madonna dell'Ulivo",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-dell-olivo": [{
      "hkey": "fa2405aa",
      "slug": "calisese-madonna-dell-ulivo",
      "name": "Calisese-Madonna dell'Ulivo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "a402ecf3": [{
      "hkey": "8bd4c7d8",
      "slug": "martorano-villa-chiaviche",
      "name": "Martorano-Villa Chiaviche",
      "primary": true,
      "skipSearch": false
    }],
    "martorano": [{
      "hkey": "8bd4c7d8",
      "slug": "martorano-villa-chiaviche",
      "name": "Martorano-Villa Chiaviche",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0bb7f729": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "skipSearch": false
    }],
    "massa": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "832554c7": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "skipSearch": false
    }],
    "oltresavio": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "301c72ca": [{
      "hkey": "6d3ae92b",
      "slug": "osservanza-monte",
      "name": "Osservanza-Monte",
      "primary": true,
      "skipSearch": false
    }],
    "osservanza": [{
      "hkey": "6d3ae92b",
      "slug": "osservanza-monte",
      "name": "Osservanza-Monte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8e6e9665": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "skipSearch": false
    }],
    "pievesestina": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "16ef38ad": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "pioppa": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "895f7e8c": [{
      "hkey": "0701e38d",
      "slug": "ponte-abbadesse-rio-eremo",
      "name": "Ponte Abbadesse-Rio Eremo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-abbadesse": [{
      "hkey": "0701e38d",
      "slug": "ponte-abbadesse-rio-eremo",
      "name": "Ponte Abbadesse-Rio Eremo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0f2f150c": [{
      "hkey": "b8fa3ad0",
      "slug": "bagnile-pontecucco-san-giorgio",
      "name": "Bagnile-Pontecucco-San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "pontecucco": [{
      "hkey": "b8fa3ad0",
      "slug": "bagnile-pontecucco-san-giorgio",
      "name": "Bagnile-Pontecucco-San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "79395e24": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "porta-santi": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "1d47e9a7": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "porta-trova": [{
      "hkey": "9fd7ec94",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "1adf1eef": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "skipSearch": false
    }],
    "provezza": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "1186e6df": [{
      "hkey": "0701e38d",
      "slug": "ponte-abbadesse-rio-eremo",
      "name": "Ponte Abbadesse-Rio Eremo",
      "primary": true,
      "skipSearch": false
    }],
    "rio-eremo": [{
      "hkey": "0701e38d",
      "slug": "ponte-abbadesse-rio-eremo",
      "name": "Ponte Abbadesse-Rio Eremo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "925a2868": [{
      "hkey": "83202cd4",
      "slug": "rio-marano-saiano-san-tomaso",
      "name": "Rio Marano-Saiano-San Tomaso",
      "primary": true,
      "skipSearch": false
    }],
    "rio-marano": [{
      "hkey": "83202cd4",
      "slug": "rio-marano-saiano-san-tomaso",
      "name": "Rio Marano-Saiano-San Tomaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1c3d393d": [{
      "hkey": "139a91b4",
      "slug": "san-martino-in-fiume-ronta",
      "name": "San Martino in Fiume-Ronta",
      "primary": true,
      "skipSearch": false
    }],
    "ronta": [{
      "hkey": "139a91b4",
      "slug": "san-martino-in-fiume-ronta",
      "name": "San Martino in Fiume-Ronta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "5bdd4add": [{
      "hkey": "72b1154d",
      "slug": "montereale-roversano",
      "name": "Montereale-Roversano",
      "primary": true,
      "skipSearch": false
    }],
    "roversano": [{
      "hkey": "72b1154d",
      "slug": "montereale-roversano",
      "name": "Montereale-Roversano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c4eea36a": [{
      "hkey": "83202cd4",
      "slug": "rio-marano-saiano-san-tomaso",
      "name": "Rio Marano-Saiano-San Tomaso",
      "primary": true,
      "skipSearch": false
    }],
    "saiano": [{
      "hkey": "83202cd4",
      "slug": "rio-marano-saiano-san-tomaso",
      "name": "Rio Marano-Saiano-San Tomaso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "9235569e": [{
      "hkey": "e8ef6ea9",
      "slug": "san-carlo-san-vittore-tessello",
      "name": "San Carlo-San Vittore-Tessello",
      "primary": true,
      "skipSearch": false
    }],
    "san-carlo": [{
      "hkey": "e8ef6ea9",
      "slug": "san-carlo-san-vittore-tessello",
      "name": "San Carlo-San Vittore-Tessello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "54a9dbd0": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "skipSearch": false
    }],
    "san-cristoforo": [{
      "hkey": "cfaf90e5",
      "slug": "pievesestina-provezza-san-cristoforo",
      "name": "Pievesestina-Provezza-San Cristoforo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "82898c17": [{
      "hkey": "b8fa3ad0",
      "slug": "bagnile-pontecucco-san-giorgio",
      "name": "Bagnile-Pontecucco-San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio": [{
      "hkey": "b8fa3ad0",
      "slug": "bagnile-pontecucco-san-giorgio",
      "name": "Bagnile-Pontecucco-San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "b06eec54": [{
      "hkey": "139a91b4",
      "slug": "san-martino-in-fiume-ronta",
      "name": "San Martino in Fiume-Ronta",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-in-fiume": [{
      "hkey": "139a91b4",
      "slug": "san-martino-in-fiume-ronta",
      "name": "San Martino in Fiume-Ronta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e601fa9d": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "skipSearch": false
    }],
    "san-mauro-in-valle": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e571897b": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "d861cf81",
      "slug": "san-mauro-in-valle-san-rocco",
      "name": "San Mauro in Valle-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "7b329d9d": [{
      "hkey": "e8ef6ea9",
      "slug": "san-carlo-san-vittore-tessello",
      "name": "San Carlo-San Vittore-Tessello",
      "primary": true,
      "skipSearch": false
    }],
    "san-vittore": [{
      "hkey": "e8ef6ea9",
      "slug": "san-carlo-san-vittore-tessello",
      "name": "San Carlo-San Vittore-Tessello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "ff188515": [{
      "hkey": "edb7aa0c",
      "slug": "sant-egidio-vigne-case-frini",
      "name": "Sant'Egidio-Vigne-Case Frini",
      "primary": true,
      "skipSearch": false
    }],
    "sant-egidio": [{
      "hkey": "edb7aa0c",
      "slug": "sant-egidio-vigne-case-frini",
      "name": "Sant'Egidio-Vigne-Case Frini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "11a5219a": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "skipSearch": false
    }],
    "settecrociari": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "27c2b156": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "skipSearch": false
    }],
    "tipano": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "b48e07fc": [{
      "hkey": "d4fa3da9",
      "slug": "ippodromo-torre-del-moro",
      "name": "Ippodromo-Torre del Moro",
      "primary": true,
      "skipSearch": false
    }],
    "torre-del-moro": [{
      "hkey": "d4fa3da9",
      "slug": "ippodromo-torre-del-moro",
      "name": "Ippodromo-Torre del Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "e11f872a": [{
      "hkey": "edb7aa0c",
      "slug": "sant-egidio-vigne-case-frini",
      "name": "Sant'Egidio-Vigne-Case Frini",
      "primary": true,
      "skipSearch": false
    }],
    "vigne": [{
      "hkey": "edb7aa0c",
      "slug": "sant-egidio-vigne-case-frini",
      "name": "Sant'Egidio-Vigne-Case Frini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "7024f385": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "skipSearch": false
    }],
    "villa-calabra": [{
      "hkey": "2b4e0050",
      "slug": "calabrina-capannaguzzo-gattolino-pioppa",
      "name": "Calabrina-Capannaguzzo-Gattolino-Pioppa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "d3d8ccb6": [{
      "hkey": "e03aade9",
      "slug": "bulgarno-macerone-ruffio",
      "name": "Bulgarnò-Macerone-Ruffio",
      "primary": true,
      "skipSearch": false
    }],
    "villa-casone": [{
      "hkey": "e03aade9",
      "slug": "bulgarno-macerone-ruffio",
      "name": "Bulgarnò-Macerone-Ruffio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "d3422d0f": [{
      "hkey": "8bd4c7d8",
      "slug": "martorano-villa-chiaviche",
      "name": "Martorano-Villa Chiaviche",
      "primary": true,
      "skipSearch": false
    }],
    "villa-chiaviche": [{
      "hkey": "8bd4c7d8",
      "slug": "martorano-villa-chiaviche",
      "name": "Martorano-Villa Chiaviche",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "e1d52a18": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "skipSearch": false
    }],
    "villa-silvia": [{
      "hkey": "6f61bbe5",
      "slug": "settecrociari-tipano-lizzano",
      "name": "Settecrociari-Tipano-Lizzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "7b797fc4": [{
      "hkey": "13e5337a",
      "slug": "cesena",
      "name": "Cesena",
      "primary": true,
      "skipSearch": false
    }],
    "zona-agraria": [{
      "hkey": "13e5337a",
      "slug": "cesena",
      "name": "Cesena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9c67517": [{
      "hkey": "0701e38d",
      "slug": "ponte-abbadesse-rio-eremo",
      "name": "Ponte Abbadesse-Rio Eremo",
      "primary": true,
      "skipSearch": false
    }],
    "zona-maceri": [{
      "hkey": "0701e38d",
      "slug": "ponte-abbadesse-rio-eremo",
      "name": "Ponte Abbadesse-Rio Eremo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "56065967": [{
      "hkey": "6590aeae",
      "slug": "case-finali-fiorita-ospedale-san-pietro",
      "name": "Case Finali-Fiorita-Ospedale-San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "zona-ospedale": [{
      "hkey": "6590aeae",
      "slug": "case-finali-fiorita-ospedale-san-pietro",
      "name": "Case Finali-Fiorita-Ospedale-San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }],
    "741ee008": [{
      "hkey": "6590aeae",
      "slug": "case-finali-fiorita-ospedale-san-pietro",
      "name": "Case Finali-Fiorita-Ospedale-San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "zona-stadio": [{
      "hkey": "6590aeae",
      "slug": "case-finali-fiorita-ospedale-san-pietro",
      "name": "Case Finali-Fiorita-Ospedale-San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesena"
    }]
  }
};
exports["default"] = _default;